import { useMemo } from 'react';
import { COLORS } from '../styled';

export type CourseState = 'PASSED' | 'FAILED' | 'NOT_EVALUATED' | 'IN_PROGRESS';

export const useCourseStyles = () => {
  const getCourseStateText = useMemo(
    () =>
      (state: CourseState): string => {
        switch (state) {
          case 'PASSED':
            return 'Cumple requisito';
          case 'FAILED':
            return 'No cumple requisito';
          case 'NOT_EVALUATED':
            return 'Sin evaluar';
          case 'IN_PROGRESS':
            return 'En curso';
          default:
            return '';
        }
      },
    []
  );

  const getCourseStateColor = useMemo(
    () =>
      (state: CourseState): string => {
        switch (state) {
          case 'PASSED':
            return COLORS.success;
          case 'FAILED':
            return COLORS.error;
          case 'NOT_EVALUATED':
            return COLORS.neutral;
          case 'IN_PROGRESS':
            return COLORS.warning;
          default:
            return COLORS.black;
        }
      },
    []
  );

  return {
    getCourseStateText,
    getCourseStateColor
  };
};
